import React from 'react'
import styled from 'styled-components';
import { useGlobalContext } from './context';
import {Button} from "../src/styles/Button";

import { NavLink } from 'react-router-dom';

const Services = () => {
  const {services} = useGlobalContext();

  return (
    <Wrapper className="section">

    <h2 className="commor-heading"> Our Services </h2>

    <div className='container grid grid-three-column'>
      {services.map((currElem)=>{
        const {id, name, image, description} = currElem;
        return(<div key={id} className="card">
          <figure>
            <img src = {image} alt = {name} />
          </figure>
          <div className='card-data'>
            <h3>{name}</h3>
            <p>{description}</p>
            <NavLink to = "/" >
            <Button className='btn'>Read More</Button></NavLink>
          </div>
        </div>);
      })}
    </div>

         
    </Wrapper>
  )
}

const Wrapper = styled.section`
padding: 9rem 0;
margin: 10%;

background-color: ${({theme})=> theme.colors.bg};

.container{
  max-width: 120rem;
}
.card{
  border: 0.1rem solid rgba(170 170 170 / 40%);

  .card-data{
    padding:  0 2rem;
  }

  h3{
    margin: 2rem 0;
    font-weight:  300;
    font-size:  2.4rem;
  }

  .btn{
    margin: 2rem auto;
    background-color: rgba(0 0 0/ 0%);
    border: 0.1rem solid rgb(98, 84, 243);
    display:flex;
    color: rgb(98, 84, 243);
    justify-content: center:
    align-items: center;
    font-size:1.4rem;
    &:hover{
      background-color: rgb(98, 84, 243);
      color: #fff;

    }

    
  }
}
figure{
  width:auto;
  display:flex;
  justify-content: center;
  align-items:center;
  position: relative;
  overflow: hidden;
  transition: all 0.5s linear;
  &::after{
    content: "";
    position: absolute;
    top: 0;
    left: 0;
  width: 0%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5s);
  transition:all 0.2s linear;
  cursor: pointer;
}
&:hover::after{
  width: 100%;
}
&:hover img{
  transform: scale(1.2); 
}

}

img{
  max-width: 90%;
  margin-top: 1.5rem;
  height: 20rem;
  transition: all 0.2s linear; 
}

@media (max-width: ${({theme})=> theme.media.tab}){
    .grid-three-column{
      grid-template-columns: 1fr 1fr;
    }
}

@media (max-width: ${({theme})=> theme.media.mobile}){
    .grid{
        gap: 3.2rem;
    }
    .grid-two-column, .grid-three-column{
      grid-template-columns: 1fr;
   
    }
}

`;

export default Services